import { ShieldCheck, Wallet, HandCoins, ArrowLeftRight } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const FEATURES = [
  { icon: Wallet, t: "Buku tabungan digital", d: "Pantau simpanan pokok, wajib & sukarela" },
  { icon: HandCoins, t: "Pinjaman & simulasi", d: "Ajukan pinjaman dan hitung angsuran" },
  { icon: ArrowLeftRight, t: "Bayar & transfer", d: "Diproses aman oleh tim admin CU" },
];

export default function Login() {
  const { login } = useAuth();
  return (
    <div className="max-w-md mx-auto min-h-screen bg-white relative overflow-hidden sm:shadow-2xl">
      <div className="absolute -top-24 -left-24 h-72 w-72 rounded-full bg-red-600" />
      <div className="absolute -bottom-28 -right-20 h-72 w-72 rounded-full bg-blue-800" />
      <div className="relative px-7 pt-16 pb-10 flex flex-col min-h-screen">
        <div className="bg-white keep-white rounded-3xl px-4 py-3 mx-auto shadow-xl fade-up w-full max-w-[340px]">
          <img src="/brand-banner.webp" alt="Credit Union Tuah Talino - Koperasi Simpan Pinjam" className="w-full h-auto object-contain" data-testid="login-logo" />
        </div>
        <p className="text-center text-slate-600 italic mt-5 text-sm fade-up" style={{ animationDelay: "140ms" }}>Bersama Tumbuh, Bersama Sejahtera</p>

        <div className="mt-10 space-y-3">
          {FEATURES.map(({ icon: Icon, t, d }, i) => (
            <div key={t} className="flex items-center gap-4 bg-slate-50 border border-slate-200 rounded-2xl p-4 fade-up" style={{ animationDelay: `${200 + i * 80}ms` }}>
              <div className="h-11 w-11 rounded-xl bg-blue-50 flex items-center justify-center"><Icon className="h-5 w-5 text-blue-800" /></div>
              <div>
                <div className="font-semibold text-slate-900 text-sm">{t}</div>
                <div className="text-xs text-slate-500">{d}</div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-auto pt-10">
          <button onClick={login} data-testid="google-login-button"
            className="w-full flex items-center justify-center gap-3 bg-red-600 hover:bg-red-700 active:scale-[0.98] text-white font-semibold py-4 rounded-2xl shadow-lg shadow-red-600/30 transition-[background-color,transform]">
            <svg className="h-5 w-5 bg-white rounded-full p-0.5" viewBox="0 0 48 48"><path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3C33.7 32.7 29.2 36 24 36c-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.8 1.2 7.9 3.1l5.7-5.7C34 6.1 29.3 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.3-.1-2.4-.4-3.5z"/><path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.7 15.1 19 12 24 12c3.1 0 5.8 1.2 7.9 3.1l5.7-5.7C34 6.1 29.3 4 24 4 16.3 4 9.7 8.3 6.3 14.7z"/><path fill="#4CAF50" d="M24 44c5.2 0 9.9-2 13.4-5.2l-6.2-5.2C29.2 35.1 26.7 36 24 36c-5.2 0-9.6-3.3-11.3-7.9l-6.5 5C9.5 39.6 16.2 44 24 44z"/><path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.2-2.2 4.2-4.1 5.6l6.2 5.2C37 39.2 44 34 44 24c0-1.3-.1-2.4-.4-3.5z"/></svg>
            Masuk dengan Google
          </button>
          <p className="flex items-center justify-center gap-1.5 text-[11px] text-slate-600 mt-4 relative bg-white/80 rounded-full py-1 w-fit mx-auto px-3">
            <ShieldCheck className="h-3.5 w-3.5" /> Data anggota terlindungi
          </p>
        </div>
      </div>
    </div>
  );
}
